import React, { useState, useEffect } from "react";

import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./i18n/config";
import i18next from "i18next";
import { Row, Col } from "react-bootstrap";
import { Image } from "react-bootstrap";
import * as moment from 'moment';
import NumberFormat from 'react-number-format';
import apiService from "./services/api.service";
import { selectCartItems } from "./Redux/shoppingCartReducer";
import { useSelector } from "react-redux";
import Select from 'react-select'
import CompanyProductSummaryMobile from "./companyComponents/CompanyProductSummaryMobile";
import CompanyProductSummaryDesktop from "./companyComponents/CompanyProductSummaryDesktop";



function ShoppingCartItemComponent(props) {

  const [lang, setLang] = useState("");
  const [isOpenMoreDetails, setIsOpenMoreDetails] = useState(false);
  const orderNUm = sessionStorage.getItem("lastOrderNum") || 0;
  const [myOrder, setmyOrder] = useState("");
  const companyUser = useSelector((state) => state.company.companyUser)
  const { t } = useTranslation();
  const location = useLocation();
  let cartItems = useSelector(selectCartItems);
  const productsFromSession = window.sessionStorage.getItem("products");
  cartItems = productsFromSession ? JSON.parse(productsFromSession) : cartItems;
  let currencyCode = Object.values(cartItems)[0]?.selectedProduct.currencyCode || ""
  const [selectedWorkers, setSelectedWorkers] = useState([])
  const workers = useSelector((state) => state.company.workers)

  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };

  useEffect(() => {
    if (workers) {
      let workersParsed = []
      workers.map((worker) => {
        workersParsed.push({
          value: worker.companyWorkerId, label: worker.workerFirstName + " " + worker.workerLastName,
        })
      })
      setSelectedWorkers(workersParsed)
    }
  }, [])

  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");
    if (props.isConfirmation) {
      getMyOrder(orderNUm);
    }
  }, []);

  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);

  const getProductTranslations = (prod) => {
    if (prod && prod.translations) {
      let ProductTranslations = prod.translations.filter((p) => {
        return p.languageIsoCode == lang && p.propductId == prod.propductId;
      });
      return ProductTranslations.length > 0 ? ProductTranslations[0] : {};
    }
    return {};
  };

  const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return moment(result).format('DD/MM/YYYY');
  }
  const getQty = () => {
    if (companyUser) {
      return props.currentItem.qty
    }
    return props.currentItem.qty > 1 ? " × " + props.currentItem.qty : "";
  }
  const getProdName = () => {
    return getProductTranslations(props.currentProduct).productName ? getProductTranslations(props.currentProduct).productName : props.currentProduct.productName;
  }
  const getMyOrder = (orderId) => {
    apiService.getOrders({ orderId: orderId })
      .then(
        (response) => {
          if (response.data && response.data.data && response.data.data.length > 0) {
            setmyOrder(response.data.data[0])
          }
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
  };

  const getTotalPrice = () => {
    let price = 0
    {
      Object.keys(cartItems).map((k, ind) => {
        const currentItem = cartItems[k];
        price += currentItem.selectedProduct.productPriceAfterDiscount * currentItem.qty
      })
    }
    return price
  }

  const getCurrency = () => {
    return props.currentProduct.currencyCode
      ? props.currentProduct.currencyCode.replace("ILS", "₪")
      : props.currentProduct.currencyCode
  }

  return (
    <>
      {
        props.isConfirmation ?
          <Row>
            <Col className="expdate">{t("expDate")}
              <span> {props.currentProduct.duration && myOrder && myOrder.orderPlacementDate ? addDays(myOrder.orderPlacementDate, props.currentProduct.duration) : props.currentProduct.expiryDate ? moment(props.currentProduct.expiryDate).format('DD/MM/YYYY') : ""} </span>
            </Col>
          </Row> : null
      }
      {
        companyUser ?
          <>
            <CompanyProductSummaryMobile
              getProdName={getProdName}
              getCurrency={getCurrency}
              currencyCode={currencyCode}
              itemCount={props.itemCount}
              getTotalPrice={getTotalPrice}
              currentProduct={props.currentProduct}
            />
            {
              selectedWorkers.length > 0 &&
              <div className="mb-4 hidden-desk">
                <span>{t("youSelectedToSend")}</span>
                <Select
                  id="select-worker"
                  className="select-workers disabled-options"
                  options={selectedWorkers}
                  isSearchable={false}
                  value={t("youChose") + " " + selectedWorkers.length + " " + t("recipients")}
                  placeholder={t("youChose") + " " + selectedWorkers.length + " " + t("recipients")}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 3,
                    colors: {
                      ...theme.colors,
                      primary25: 'white',
                      primary: '#5A687E',
                      primary50: 'white',
                    },
                  })}
                />
              </div>
            }
            <CompanyProductSummaryDesktop
              getProdName={getProdName}
              getCurrency={getCurrency}
              currencyCode={currencyCode}
              itemCount={props.itemCount}
              getTotalPrice={getTotalPrice}
              currentProduct={props.currentProduct}
            />
            {selectedWorkers.length > 0 &&
              <div className="d-flex justify-content-end hidden-mobile">
                <div className="w-50 pe-4">
                  <span>{t("youSelectedToSend")}</span>
                  <div>
                    <Select
                      readOnly
                      id="select-worker"
                      className="select-workers disabled-options"
                      options={selectedWorkers}
                      isSearchable={false}
                      value={t("youChose") + " " + selectedWorkers.length + " " + t("recipients")}
                      placeholder={t("youChose") + " " + selectedWorkers.length + " " + t("recipients")}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 3,
                        colors: {
                          ...theme.colors,
                          primary25: 'white',
                          primary: '#5A687E',
                          primary50: 'white',
                        },
                      })}
                    />
                  </div>
                </div>
              </div>
            }
          </>
          :
          <>
            <Row key={`item-${props.currentProduct.productId}`} className={"shop-item " + props.topCart ? "top-cart" : ""}>
              {!props.isConfirmation && 
              <Col className="position-relative"> {props.currentProduct.images && props.currentProduct.images.length > 0 ? <Image className="gift-img" alt={getProdName()} src={props.currentProduct.images[0].fullURL} /> : null}

                  <div className="float-price hidden-desk">
                    <NumberFormat value={props.currentProduct.productPrice * props.currentItem.qty} displayType={'text'} thousandSeparator={true} prefix={props.currentProduct.currencyCode
                      ? props.currentProduct.currencyCode.replace("ILS", "₪")
                      : props.currentProduct.currencyCode} />
                  </div>
              </Col>
              }
              <Col lg={7}>

                <>
                  <h3 className="name" aria-label={getProdName()} dangerouslySetInnerHTML={{ __html: getProdName() + getQty() }}></h3>
                  <div>{getProductTranslations(props.currentProduct)?.productShortDescription}</div>
                  {getProductTranslations(props.currentProduct)?.productDescription && getProductTranslations(props.currentProduct)?.productDescription.length > 1 ?
                    <div className="more-info">
                      <button onClick={e => setIsOpenMoreDetails(!isOpenMoreDetails)} aria-label={!isOpenMoreDetails ? t("moreInfo") : t("close")}>{!isOpenMoreDetails ? t("moreInfo") : t("close")}</button>
                    </div>
                    : null}
                </>
              </Col>
              <Col>
                <div role="application" aria-roledescription={t("price")} aria-label={(props.currentProduct.productPrice * props.currentItem.qty) + (props.currentProduct.currencyCode
                  ? props.currentProduct.currencyCode.replace("ILS", "₪")
                  : props.currentProduct.currencyCode)} className="price hidden-mobile">
                  <NumberFormat value={props.currentProduct.productPrice * props.currentItem.qty} displayType={'text'} thousandSeparator={true} prefix={props.currentProduct.currencyCode
                    ? props.currentProduct.currencyCode.replace("ILS", "₪")
                    : props.currentProduct.currencyCode} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                {isOpenMoreDetails || props.isConfirmation ? <div className={"descr " + (isOpenMoreDetails ? "open" : "")} dangerouslySetInnerHTML={{ __html: getProductTranslations(props.currentProduct)?.productDescription }}></div> : ""}
              </Col>
            </Row>
          </>
      }
    </>
  );
}

export default ShoppingCartItemComponent;
